<template>
    <div class="hero-profile-card">
        <img class="hero-profile-card__photo" :src="photoUrl" :style="{objectPosition: photoPosition}" alt="" />
        <div class="hero-profile-card__body">
            <span class="hero-profile-card__name">{{ name }}</span>
            <span v-if="jobTitle" class="hero-profile-card__job-title">{{ jobTitle }}</span>
            <span v-if="review" class="hero-profile-card__review">{{ review }}</span>
            <span class="hero-profile-card__rating">
                <span class="hero-profile-card__stars">
                    <VJoyIcon v-for="star in RATING_STARS" :key="star" name="star-fill" color="quaternary" size="xsmall" />
                </span>
                <span class="hero-profile-card__score">{{ score }}</span>
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {VJoyIcon} from '@maltjoy/core-vue';
    interface Props {
        jobTitle: string;
        name: string;
        photoPosition: string;
        photoUrl: string;
        review: string;
        score: string;
    }

    defineProps<Props>();

    const RATING_STARS = [1, 2, 3, 4, 5];
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .hero-profile-card {
        display: flex;
        align-items: center;
        gap: var(--joy-core-spacing-4);
        width: 440px;
        padding: 18px 22px 18px 16px;
        border-radius: 20px;
        background-color: color-mix(in srgb, var(--joy-color-neutral-0) 90%, transparent);
        backdrop-filter: blur(20px);
        box-shadow: 0 26px 60px rgb(20 8 8 / 30%);

        &__photo {
            display: block;
            flex: none;
            width: 70px;
            height: 70px;
            border-radius: 50%;
            object-fit: cover;
        }

        &__body {
            display: flex;
            min-width: 0;
            flex-direction: column;
            gap: 5px;
        }

        &__name {
            @include text.getFontBySize(primary-600);

            font-weight: var(--joy-font-weight-bold);
            letter-spacing: -0.015em;
        }

        &__job-title {
            color: var(--joy-color-neutral-40);

            @include text.getFontBySize(primary-600);

            font-size: 15px;
            white-space: nowrap;
        }

        &__review {
            overflow: hidden;
            color: var(--joy-color-neutral-40);
            font-size: var(--joy-font-size-primary-300);
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &__rating {
            display: flex;
            align-items: center;
            gap: var(--joy-core-spacing-2);
        }

        &__score {
            font-size: var(--joy-font-size-primary-300);
            font-weight: 600;
        }
    }
</style>
